import { render } from "./ControlIcon.vue?vue&type=template&id=dc0767b4"
import script from "./ControlIcon.vue?vue&type=script&lang=js"
export * from "./ControlIcon.vue?vue&type=script&lang=js"

import exportComponent from "/Users/biriukov/Documents/Projects/generate-web-prices/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__